import { Size } from '@ps/web-core-enums';

export const mobileBreakpoint = Size.Small;
